// Animate value proposition block: left column slides in from the left,
// right column (hexagon image) slides in from the right.
document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = Array.from( document.querySelectorAll( '.valueproposition-block' ) );
	if ( ! blocks.length ) return;

	const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

	blocks.forEach( ( block ) => {
		const grid = block.querySelector( ':scope > .container' );
		if ( ! grid ) return;

		const [ leftCol, rightCol ] = grid.children;

		if ( leftCol ) {
			leftCol.style.opacity    = '0';
			leftCol.style.transform  = 'translateX(-48px)';
			leftCol.style.transition = `opacity 0.75s ${ EASING }, transform 0.75s ${ EASING }`;
		}
		if ( rightCol ) {
			rightCol.style.opacity    = '0';
			rightCol.style.transform  = 'translateX(48px)';
			rightCol.style.transition = `opacity 0.75s ${ EASING } 0.15s, transform 0.75s ${ EASING } 0.15s`;
		}
	} );

	blocks.forEach( ( block ) => {
		const grid = block.querySelector( ':scope > .container' );
		if ( ! grid ) return;

		const [ leftCol, rightCol ] = grid.children;

		if ( leftCol ) {
			const leftObserver = new IntersectionObserver(
				( entries, obs ) => {
					entries.forEach( ( entry ) => {
						if ( ! entry.isIntersecting ) return;
						leftCol.style.opacity   = '1';
						leftCol.style.transform = 'translateX(0)';
						obs.unobserve( entry.target );
					} );
				},
				{ threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
			);
			leftObserver.observe( leftCol );
		}

		if ( rightCol ) {
			const rightObserver = new IntersectionObserver(
				( entries, obs ) => {
					entries.forEach( ( entry ) => {
						if ( ! entry.isIntersecting ) return;
						rightCol.style.opacity   = '1';
						rightCol.style.transform = 'translateX(0)';
						obs.unobserve( entry.target );
					} );
				},
				{ threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
			);
			rightObserver.observe( rightCol );
		}
	} );
} );
